"use strict";
/**
 * Created by Ning Jiang on 9/11/2019.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvalancheServerDataParser = void 0;
const ServerDataParser_1 = require("../../../core/server/ServerDataParser");
class AvalancheServerDataParser extends ServerDataParser_1.ServerDataParser {
    constructor() {
        super();
    }
    parseAllWinPositions(rawData) {
        return rawData.allWinPositions.concat();
    }
    parseReelsAfterCollapse(rawData) {
        // return ServerDataParser.parseStackedSymbolsInReels(rawData.reelsAfterCollapse); // TODO
        return rawData.reelsAfterCollapse.concat();
    }
    parseNewSymbols(rawData) {
        return rawData.newSymbols.concat(); // TODO: parse stacked symbol?
    }
    parseNearWinPositions(rawData) {
        return rawData.nearWinPositions;
    }
}
exports.AvalancheServerDataParser = AvalancheServerDataParser;
//# sourceMappingURL=AvalancheServerDataParser.js.map